import React, { Component } from 'react';

class ConseilorForm extends Component
{
    constructor(props)
    {
        super(props);

        this.onChange = props.onChange;
        
        this.handeInput = this.handeInput.bind(this);
    }

    handeInput(event)
    {
        let value = event.target.type === 'checkbox' ? (event.target.checked === true ? 1 : 0) : event.target.value;
        let evt = {
            "target" : {
                "name" : event.target.name,
                "value" : value
            } 
        }
        
        this.onChange(evt);
    }

    render()
    {
        let dealerships = this.props.dealerships == null ? [] : 
        this.props.dealerships.map((d) => {
            return (<option key={ d.shortname+' - '+d.name }value={ d.name }>{ d.name }</option>);
        });

        return (
            <form>
                <div className="row">
                    <div className="col">
                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Affaire
                            </label>
                            <select className="form-control" name="shortname" value={ this.props.conseilor.shortname } onChange={ this.handeInput } required>
                                <option disabled selected value=""> -- Affaire -- </option>
                                {dealerships}
                            </select>
                        </div>
                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Nom
                            </label>
                            <div className="input-group mb-3">
                                <input type="text" maxLength="100" className="form-control" name="name" value={ this.props.conseilor.name } onChange={ this.handeInput } />
                                <small className="text-danger form-text">
                                    Ce champ doit contenir moins de 100 caractères.
                                </small>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Type de vendeur
                            </label>
                            <select className="form-control" name="type" value={ this.props.conseilor.type } onChange={ this.handeInput } required>
                                <option disabled selected value=""> --  Type de vendeur -- </option>
                                <option value="MAGASIN">Magasin</option>
                                <option value="HALL">Hall</option>
                                <option value="SECTEUR">Secteur</option>
                                <option value="DACIA">Dacia</option>
                                <option value="INTERNET">Internet</option>
                                <option value="SOCIETES">Sociétés</option>
                                <option value="VO">VO</option>
                                <option value="ARCOS">Arcos</option>
                                <option value="ECOLE DE VENTE">Ecole de vente</option>
                            </select>
                        </div>
                    </div> 
                </div>
            </form>
        );
    }
}

export default ConseilorForm;


// WEBPACK FOOTER //
// ./src/Components/Conseilor/ConseilorForm.js